import { inject, observer } from 'mobx-react';
import React from 'react';
import { ModalContent, Modal } from 'telia-front-react';
import GravityForm from '../../forms/GravityForm';
import PersonalOffersStore from '../../stores/PersonalOffersStore';

interface B2BGravityFormModalProps {
  formName: string;
  personalOffersStore?: PersonalOffersStore;
}

@observer
class B2BGravityFormModal extends React.Component<B2BGravityFormModalProps> {
  public render() {
    const { formName } = this.props;
    return (
      <Modal isClosable={true} size="8-col">
        <ModalContent>
          <GravityForm name={formName} />
        </ModalContent>
      </Modal>
    );
  }
}

export default inject('personalOffersStore')(B2BGravityFormModal);
